import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    name: 'Name',
    price: 'Unit price excl. VAT',
    seeMore: 'See more',
    type: 'Type',
    vat: 'VAT',
  },
  fr: {
    name: 'Nom',
    price: 'Prix unit. HT',
    seeMore: 'Voir plus',
    type: 'Type',
    vat: 'TVA',
  },
} as const);

export default locales;
